var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"fixed","right":"5px","bottom":"2em","z-index":"1000"}},_vm._l((_vm.Notificaciones),function(item,i){return _c('div',{key:i},[_c('Notificacion',{attrs:{"Tipo":item.Tipo,"Mensaje":item.Mensaje}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }